import React                     from 'react';
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';

import IconEnoughStock          from 'images/bom/stock.png'
import IconNoEnoughStock        from 'images/bom/no-enough-stock.png'
import IconNoStock               from 'images/bom/no-stock.png'
import IconNoPerfectMatch        from 'images/bom/no-perfect-match.png'
import IconNotFound              from 'images/bom/not-found.png'
import IconSubstitutePart        from 'images/bom/substitute-part.png'

import {
  getPartStatus,
}from 'pu-utils/PartsUtilities';   

const renderStatus = (status) =>{
  switch(status){
      case 'enough-stock': return IconEnoughStock;
      case 'no-enough-stock': return IconNoEnoughStock;
      case 'no-stock': return IconNoStock;
      case 'no-perfect-match': return IconNoPerfectMatch;
      case 'not-found': return IconNotFound;
      case 'substitute': return IconSubstitutePart;
      case 'other': return IconSubstitutePart;
      default: return IconNotFound;
  }
}

const PartStatus = (props) => {
  var status = getPartStatus(props.status, props.selected_quantity)

  return(
    <img className="part-status icon-bom-admin" 
     src={renderStatus(status)} 
     alt="Part Status" /> 
  )
}

export default PartStatus;
